import React from 'react';
import { Link } from 'react-router'
import WorksTypeSmall from './WorksTypeSmall'
import $ from 'jquery'

let config = require('config');

let backArrow   = require('../images/back_arrow.svg')
let backArrowHover = require('../images/back_arrow_ov.svg')
let videoPlayTriangle = require('../images/video_play_triangle.svg')

var currentId = ""
var isLoadRecentWorks = false
var slideCurrentNum = 0
var isSetYoutube = false
var youtubeMovies = []

class WorksDetail extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      slideNum:0
    }
    this.changeSlide  = this.changeSlide.bind(this);

  }

  componentDidMount() {
    document.getElementsByTagName('body')[0].id = "works_side"
    const { actions, params } = this.props;
    currentId = params.slug
    actions.getWorksById(currentId)
  }

  componentDidUpdate() {
    const { actions, data, params } = this.props;

    if (params.slug != currentId) {
      currentId = params.slug
      slideCurrentNum = 0
      actions.getWorksById(currentId)
      data.worksSingle = null
      isLoadRecentWorks = false
    }

    if (data.worksSingle) {
      if (!isLoadRecentWorks) {
        isLoadRecentWorks = true
        actions.getRecentWorksByMembers(data.worksSingle.member, 4, currentId)
      }
    }

  }

  componentWillUnmount() {
    document.getElementsByTagName('body')[0].id = ""
    const { data, params } = this.props;
    currentId = ""
    isSetYoutube = false
    isLoadRecentWorks = false
    data.worksSingle = null
    youtubeMovies = []
  }

  changeSlide(e) {
    var num = $(e.currentTarget).data("num")
    $(".mainslide__thumbnails .image_block").removeClass("current")
    $(".mainslide__thumbnails .image_block").eq(num).addClass("current")
    this.setState({ slideNum:num });
    return
  }

  render() {
    const { actions, data } = this.props;
    var self   = this
    var works  = data.worksSingle;
    var recent = data.works;
    if (works) {
      document.title = works.title + " | WORKS | " + config.default.SITE_NAME
      var mainImage  = works.images[this.state.slideNum]
    }
    return (
      <div id="works-detail" className="main detail">
        { works ?
            <div className="works-detail_inner">
              <div className="works-detail__header works__side">
                <div className="header__back">
                  <Link to={"/"}><img className="def" src={backArrow} /><img className="ov" src={backArrowHover} /></Link>
                </div>
                <h1>{works.title}</h1>
              </div>
              <div className="works-detail__mainslide">
                <div className="mainslide__images">
                  { mainImage.youtube ?
                      <div className={"image_block youtube_player current"} data-videoid={mainImage.youtube} dangerouslySetInnerHTML={{__html:mainImage.youtube}} />
                    :
                      <div className={"image_block current"}><div className="image" style={{backgroundImage:"url(" + mainImage.image.url + ")"}}></div></div>
                  }
                </div>
                <div className="mainslide__thumbnails works__side">
                  { works.images.map(function(image, i) {
                    var cl = ""
                    if (i == 0) cl = "current"
                    if (image.youtube_thumbnail) {
                      return (
                        <div key={i} className={"image_block " + cl}><a onClick={self.changeSlide} data-num={i}><span><img src={videoPlayTriangle} /></span><div className="image" style={{backgroundImage:"url(" + image.youtube_thumbnail.url + ")"}} /></a></div>
                      )
                    } else {
                      return (
                        <div key={i} className={"image_block " + cl}><a onClick={self.changeSlide} data-num={i}><div className="image" style={{backgroundImage:"url(" + image.image.url + ")"}} /></a></div>
                      )
                    }
                  })}
                </div>
              </div>
              <div className="works-detail__content works__side">
                <div className="content__side">
                  <div className="side__info">
                    <div className="info__date">{works.date}</div>
                    { works.is_former_job ?
                        <div className="info__note">
                          <span>前所属会社での実績</span>
                        </div>
                      :null
                    }
                  </div>
                  <div className="side__members">
                    <ul>
                      { works.member.map(function(m, j) {
                        return (
                          <li key={j}><Link to={"/member/" + m.id + "/"}>{m.name_en}</Link></li>
                        )
                      })}
                    </ul>
                  </div>
                </div>
                <div className="content__body">
                  <div className="body__text" dangerouslySetInnerHTML={{__html:works.text}} />
                  <div className="body__credits">
                    <div className="credits__title">CREDITS</div>
                    <div className="credits__top" dangerouslySetInnerHTML={{__html:works.credits_main}} />
                    <div className="credits__bottom" dangerouslySetInnerHTML={{__html:works.credits_small}} />
                  </div>
                </div>
              </div>
              <div className="works-detail__recentworks works__side">
                <div className="recentworks__title">RECENT WORKS</div>
                <div className="recentworks__content">
                  <WorksTypeSmall works={recent} />
                </div>
              </div>
            </div>
          :null
        }
      </div>
    );
  }
}

WorksDetail.displayName = 'WorksDetail';
WorksDetail.propTypes = {};
WorksDetail.defaultProps = {};

export default WorksDetail;



// WEBPACK FOOTER //
// ./components/WorksDetail.js